import { render } from "./PontajComponentaSuma.vue?vue&type=template&id=7452f67a&scoped=true&ts=true"
import script from "./PontajComponentaSuma.vue?vue&type=script&lang=ts"
export * from "./PontajComponentaSuma.vue?vue&type=script&lang=ts"

import "./PontajComponentaSuma.vue?vue&type=style&index=0&id=7452f67a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7452f67a"]])

export default __exports__